import React, { useState } from 'react';

export default function Section5() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "1. WHAT IS FINKEY START ?",
            answer: "For unregistered users, or after external meetings to recruit third-party platform"
        },
        {
            question: "2. HOW DO I START TRADING?",
            answer: "Answer for how to start trading..."
        },
        {
            question: "3. WHAT ASSETS CAN I TRADE?",
            answer: "Answer for available assets..."
        },
        {
            question: "4. IS MY GRYPTO SECURE ON FINKEY STAR?",
            answer: "Answer about security measures..."
        },
        {
            question: "5. WHAT IF THE ASSET I WANT TO TRADE ISN'T SUPPORTED?",
            answer: "Answer about unsupported assets..."
        }
    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className=' w-[90%] mx-auto pb-10 lg:pb-20'>
            <h1 className="text-[#269DDF] text-center font-bold text-2xl lg:text-3xl uppercase">FAQS</h1>

            <div className="mt-5 space-y-4" data-aos='fade-up' data-aos-duration='1500'>
                {faqs.map((faq, index) => (
                    <div key={index} className={`py-5 px-5 lg:px-10 rounded-xl ${activeIndex === index ? 'border border-[#269DDF] bg-[#269DDF]/25' : 'bg-white/20'} `}>
                        <button
                            className="flex gap-3 justify-between items-center w-full text-left focus:outline-none"
                            onClick={() => toggleFAQ(index)}
                        >
                            <span className="text-lg font-medium text-white">{faq.question}</span>
                            <div>
                                <button className={`cursor-pointer transition-transform duration-300 w-5 h-5 text-xs rounded-full ${activeIndex === index ? 'rotate-90 bg-[#269DDF]' : 'bg-white text-[#269DDF]'}`}>
                                    <i className='fa-solid fa-chevron-right' />
                                </button>
                            </div>
                        </button>

                        <div
                            className={`overflow-hidden transition-all duration-500 ease-in-out `}
                            style={{
                                maxHeight: activeIndex === index ? '200px' : '0',
                                opacity: activeIndex === index ? 1 : 0,
                                transitionProperty: 'max-height, opacity',
                            }}
                        >
                            <div className="mt-2">
                                {faq.answer}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
